module.exports = __webpack_public_path__ + "img/33_60.2331502e.png";